<template>
  <v-container fluid max-wdith="600px">
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <h1>今すぐ、ログイン！</h1>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-form>
          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            label="メールアドレス"
            type="email"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          ></v-text-field>

          <v-text-field
            v-model="password"
            :error-messages="passwordErrors"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            label="パスワード"
            counter
            @click:append="show = !show"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>

          <v-btn
            class="mt-4 primary"
            width="100%"
            height="60px"
            @click="signin"
          >
            ログインをする
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          閉じる
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { auth } from "../plugins/firebase";

export default {
  name: "Signin",
  methods: {
    signin() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.signInUserToFirebaseAuth(this.email, this.password);
      }
    },
    signInUserToFirebaseAuth(email, password) {
      this.loading = true;
      auth
        .signInWithEmailAndPassword(email, password)
        .then((data) => {
          this.loading = false;
          this.$store.commit("setUid", data.user.uid);
          this.goToUserPage();
        })
        .catch((error) => {
          this.snackbar = true;
          this.loading = false;
        });
    },
    goToUserPage() {
      this.$router.push("user");
    },
  },
  data: () => ({
    password: "",
    email: "",
    show: false,
    loading: false,
    snackbar: false,
    errorMessage:
      "ログインに失敗しました。メールアドレス/パスワードをご確認ください。",
    timeout: 2000,
  }),
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push("正しいメールアドレスを入力してください");
      !this.$v.email.required && errors.push("メールアドレスは必須です");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("パスワードは8文字以上で入力してください");
      !this.$v.password.required && errors.push("パスワードは必須です");
      return errors;
    },
  },
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8) },
  },
};
</script>

<style scoped>
.container {
  max-width: 400px;
}
</style>
